/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S5_P1Inputs */

const en_guide_json_schema_s5_p1 = /** @type {(inputs: Guide_Json_Schema_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you work with TypeScript, you might wonder why you need JSON Schema when you already have type checking. The key difference is that TypeScript types only exist at compile time: they're erased when your code runs. JSON Schema validates data at runtime, which is essential for external data (API inputs, file uploads, user input).`)
};

const ko_guide_json_schema_s5_p1 = /** @type {(inputs: Guide_Json_Schema_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TypeScript를 사용한다면 이미 타입 검사가 있는데 왜 JSON Schema가 필요한지 궁금할 수 있습니다. 핵심 차이점은 TypeScript 타입은 컴파일 시에만 존재하며 코드가 실행될 때 사라진다는 것입니다. JSON Schema는 런타임에 데이터를 검증하므로 외부 데이터(API 입력, 파일 업로드, 사용자 입력)에 필수적입니다.`)
};

const ja_guide_json_schema_s5_p1 = /** @type {(inputs: Guide_Json_Schema_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TypeScriptを使用している場合、型チェックがあるのになぜJSON Schemaが必要なのかと思うかもしれません。重要な違いは、TypeScriptの型はコンパイル時にのみ存在し、コードの実行時には消去されるということです。JSON Schemaはランタイムでデータを検証するため、外部データ（API入力、ファイルアップロード、ユーザー入力）には不可欠です。`)
};

/**
* | output |
* | --- |
* | "If you work with TypeScript, you might wonder why you need JSON Schema when you already have type checking. The key difference is that TypeScript types only ..." |
*
* @param {Guide_Json_Schema_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s5_p1 = /** @type {((inputs?: Guide_Json_Schema_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s5_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s5_p1(inputs)
	return ja_guide_json_schema_s5_p1(inputs)
});